// Shared types + type guards

export type OutcomesQuestion = {
  q: number;
  s: number;
  id: string | number;
  scale?: string[];
  question: string;
};
export type OutcomesGroup = {
  id: string | number;
  name: string;
  description?: string;
  questions: OutcomesQuestion[];
};

export type PillarQuestion = {
  q: string;
  id: number | string;
  role?: string | null;
  reverse?: boolean;
  qualifier?: string;
};
export type PillarFactor = {
  id: number | string;
  title: string;
  questions: PillarQuestion[];
};
export type PillarData = {
  type?: number;
  title?: string;
  type_name?: string;
  factors: PillarFactor[];
};

export const isOutcomes = (v: any): v is OutcomesGroup[] =>
  Array.isArray(v) && v.every((g) => Array.isArray(g?.questions));

export const isPillar = (v: any): v is PillarData =>
  v && typeof v === 'object' && Array.isArray(v.factors);

export enum QuestionTypes {
  PILLARS = 7,
  OUTCOMES = 10,
}

export enum QuestionStatus {
  ACTIVE = 2,
  ARCHIVED = 3
};